import { render, staticRenderFns } from "./Profile-Licenses.vue?vue&type=template&id=a4b9217a&scoped=true&"
import script from "./Profile-Licenses.vue?vue&type=script&lang=js&"
export * from "./Profile-Licenses.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Licenses.vue?vue&type=style&index=0&id=a4b9217a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9217a",
  null
  
)

export default component.exports